
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "FichaColorIndex",
})

export default class FichaColorIndex extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	fichas = []
	id = 0
	swEditar = false
	ficha = {
		paciente_id: null,
		cara: '',
		resina_id: '',
		fecha: DateTime.now().toFormat('yyyy-MM-dd'),
		caras: []
	}
	resinas = []
	componentes = []
	detalle=[]
	esmalte_id = null
	detalle_dentinas = []
	detalle_translucidas = []
	detalle_opacos = []
	baseURLImage = `${process.env.VUE_APP_URL_BASE}public/`;
	caras_seleccionadas = []
	panel = []
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get esmaltes(): any {
		let datos:any = []
		if(this.ficha.resina_id != ''){
			datos = this.componentes.filter(val => val.tipo == 'ESMALTE' && val.resina_id == this.ficha.resina_id && (val.posicion == this.ficha.cara || val.posicion == 'Ambos'))
		}
		return datos;
	}
	get dentinas(): any {
		let datos:any = []
		if(this.ficha.resina_id != ''){
			datos = this.componentes.filter(val => val.tipo == 'DENTINA' && val.resina_id == this.ficha.resina_id && (val.posicion == this.ficha.cara || val.posicion == 'Ambos'))
		}
		return datos;
	}
	get zonas_translucidas(): any {
		let datos:any = []
		if(this.ficha.resina_id != ''){
			datos = this.componentes.filter(val => val.tipo == 'ZONA TRANSLUCIDA' && val.resina_id == this.ficha.resina_id && (val.posicion == this.ficha.cara || val.posicion == 'Ambos'))
		}
		return datos;
	}
	get opacos(): any {
		let datos:any = []
		if(this.ficha.resina_id != ''){
			datos = this.componentes.filter(val => val.tipo == 'OPACO' && val.resina_id == this.ficha.resina_id && (val.posicion == this.ficha.cara || val.posicion == 'Ambos'))
		}
		return datos;
	}
	get caras(): any {
		return this.consultorioStore.caras;
	}
	mounted() {
		this.id = Number(this.$route.query.id)
		this.getResinas()
		this.getComponentes()
		this.getFichasColor()
	}
	async getFichasColor() {
		this.consultorioStore.loading = true;
		await http.get(`ficha-color`, {params: {paciente_id: this.paciente_id}}).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.loading = false;
				this.fichas = response.data;
			},
		})
	}
	async getResinas() {
		this.consultorioStore.loading = true;
		await http.get(`get-resinas`).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.loading = false;
				this.resinas = response.data;
			},
		})
	}
	async getComponentes() {
		this.consultorioStore.loading = true;
		await http.get(`get-componentes-resina`).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.loading = false;
				this.componentes = response.data;
			},
		})
	}
	
	editar(ficha:any){
		this.swEditar = true;
		this.ficha = ficha
	}
	guardar() {
		if (!this.$refs.form.validate()) {
      Alert.warning( `Lene todos los campos obligatorios (*)`)
      return;
    }
		Alert.confirm(`Se registrará la ficha de color`, 'Registrar Ficha?').then(async result => {
			if(result.isConfirmed){
				let datos = {
					paciente_id: this.paciente_id,
					cara: this.ficha.cara,
					resina_id: this.ficha.resina_id,
					detalles: [...[this.esmalte_id], ...this.detalle_dentinas, ...this.detalle_translucidas, ...this.detalle_opacos],
					caras: this.caras_seleccionadas,
					fecha: this.fecha
				}
				await this.storeFicha(datos).then(res =>{
					this.getFichasColor();
				})
			}
		})
  }
	async storeFicha(data:any) {
		this.consultorioStore.loading = true;
		await http.post(`ficha-color`,data).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.loading = false;
				if(response.data.res){
					Alert.successTotastr(response.data.message);
					
				}
			},
		})
	}
	async imprimir(id:number) {
		await http.get(`imprimir-ficha-color/${id}`).subscribe(response =>{
			window.open(
				`${process.env.VUE_APP_URL}imprimir-ficha-color/${id}`, "_blank");
		})
	}
	async eliminar(id:number) {
		this.consultorioStore.loading = true;
		Alert.confirm(`Se eliminará la ficha de color`, 'Eliminar Ficha?').then(async result => {
			if(result.isConfirmed){
				await http.delete(`ficha-color/${id}`).subscribe({
					next: (response:AxiosResponse) => {
						this.consultorioStore.loading = false;
						if(response.data.res){
							Alert.successTotastr(response.data.message);
							this.getFichasColor();
						}
					},
				})
			}
		})
		
	}
	
}

